import store from '@/store/store';
import { PARAMETRES_KEYS } from '@/store/modules/parametrage-mutation-type';

function getValueParamsFilter(target, value) {
  return store.getters['parametrage/parametre'](target)
    .filter(el => el.id === value)
    .map(el => el.libelle);
}

export function genererFilter() {
  return {
    codePanneau: '',
    format: '',
    materiel: '',
    codePostal: '',
    ville: '',
    adresse: '',
    tiersNomCommercial: '',
    actif: true,
  };
}

export function transformFilter(filter) {
  return {
    societeId: store.getters['societe/societeActiveId'],
    adresse: filter.adresse || '',
    tiersNomCommercial: filter.tiersNomCommercial || '',
    codePanneau: filter.codePanneau,
    formats: getValueParamsFilter(PARAMETRES_KEYS.materielFormat, filter.format),
    materiels: getValueParamsFilter(PARAMETRES_KEYS.materielType, filter.materiel),
    codesPostaux: filter.codePostal ? [filter.codePostal] : [],
    villes: filter.ville ? [filter.ville] : [],
  };
}
